import React from "react";
import cn from "classnames";
import "./Typography.scss";

const variantsMapping: Record<string, string> = {
  subheading: "subheading",
  centered: "centered",
};

interface IconSubheaderProps {
  variant?: string;
  color?: string;
  children?: React.ReactNode;
  subheader?: React.ReactNode;
  [key: string]: unknown;
}

const IconSubheader = ({
  variant,
  children,
  subheader,
  ...props
}: IconSubheaderProps) => {
  const Component = (
    variant ? variantsMapping[variant] : "p"
  ) as React.ElementType;

  return (
    <div>
      <Component
        className={cn("default-variant", {
          [`typography--variant-${variant}`]: variant,
        })}
        {...props}
      >
        {children}
        {subheader}
      </Component>
    </div>
  );
};

export default IconSubheader;
